import { Component, OnInit, ViewChild } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { DatalistviewComponent } from 'src/app/shared/datalistview/datalistview.component';

@Component({
    selector: 'app-citations',
    templateUrl: './citations.component.html',
    styleUrls: ['./citations.component.scss'],
    standalone: false
})
export class CitationsComponent implements OnInit {
  @ViewChild(DatalistviewComponent) datalistview!: DatalistviewComponent;
  
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Id", "Id"),
    new Datalistviewcolumn("Reference", "Reference"),
    new Datalistviewcolumn("Status", "CurrentStateKey"),
    new Datalistviewcolumn("Date", "IssuedDateLocalFriendlyString"),
    new Datalistviewcolumn("Plate", "PlateNumber"),
    new Datalistviewcolumn("Fee", "TotalFee"),
    new Datalistviewcolumn("Paid", "TotalPaidString"),
    new Datalistviewcolumn("Infringement Type", "InfringementTypeString"),
    new Datalistviewcolumn("Final Due", "FinalNoticeDueOnLocalFriendlyString")  
  ];

  async ngOnInit(): Promise<void> {
    // Set default sort to ID descending (newest first)
    setTimeout(() => {
      if (this.datalistview && this.datalistview.Filter) {
        this.datalistview.Filter.OrderByProperty = "Id";
        this.datalistview.Filter.Ascending = false;
      }
    });
  }

  public getStatuses() {
    return [
      "Open",
      "Resolved",
      "Pending",
      "UnderAppeal",
      "Disputed",
      "Paid",
      "Voided",
      "Final",
      "Final Overdue"
    ]
  }
} 
